(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oravi-offer"]) return;
  try {
    
(function(){
  const dialog=document.getElementById('OraviOffer');
  if(!dialog || typeof dialog.showModal!=='function') return;
  const key='oravi-offer-seen-v1';
  let seen=false;
  try{seen=sessionStorage.getItem(key)==='1';}catch(e){}
  const dismiss=()=>dialog.close();
  dialog.querySelector('button').addEventListener('click',dismiss);
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dismiss();}});
  if(!seen) setTimeout(()=>{if(document.visibilityState==='visible'&&!document.querySelector('dialog[open]')){dialog.showModal();try{sessionStorage.setItem(key,'1');}catch(e){}}},6500);
})();

  } catch(e) { console.error(e); }
})();
})();
